"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { useState, useContext } from "react";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { FOLLOW_BTN_BUTTON_CLASSES, FOLLOW_BTN_LOADER_SIZES, FOLLOW_BTN_SVG_CLASSES, UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import { useMutation } from "@tanstack/react-query";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { AuthContext } from "@/components/auth/Auth";
import type { ApiIdentitySubscriptionActions } from "@/generated/models/ApiIdentitySubscriptionActions";
import { commonApiDeleteWithBody, commonApiPost } from "@/services/api/common-api";
import { ApiIdentitySubscriptionTargetAction } from "@/generated/models/ApiIdentitySubscriptionTargetAction";
interface NotificationsFollowBtnProps {
  readonly profile: ApiProfileMin;
  readonly size?: UserFollowBtnSize | undefined;
}
const NotificationsFollowBtn: FC<NotificationsFollowBtnProps> = t0 => {
  const $ = _c(39);
  const {
    profile,
    size: t1
  } = t0;
  const size = t1 === undefined ? UserFollowBtnSize.MEDIUM : t1;
  const {
    onIdentityFollowChange
  } = useContext(ReactQueryWrapperContext);
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const [mutating, setMutating] = useState(false);
  const following = profile.subscribed_actions.length > 0;
  const label = following ? "Following" : "Follow";
  let t2;
  if ($[0] !== profile.handle) {
    t2 = async () => {
      await commonApiPost({
        endpoint: `identities/${profile.handle}/subscriptions`,
        body: {
          actions: Object.values(ApiIdentitySubscriptionTargetAction).filter(_temp)
        }
      });
    };
    $[0] = profile.handle;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onIdentityFollowChange) {
    t3 = () => {
      onIdentityFollowChange();
    };
    $[2] = onIdentityFollowChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setToast) {
    t4 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[4] = setToast;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setMutating(false);
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t6 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: t4,
      onSettled: t5
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const followMutation = useMutation(t6);
  let t7;
  if ($[11] !== profile.handle) {
    t7 = async () => {
      await commonApiDeleteWithBody({
        endpoint: `identities/${profile.handle}/subscriptions`,
        body: {
          actions: Object.values(ApiIdentitySubscriptionTargetAction).filter(_temp2)
        }
      });
    };
    $[11] = profile.handle;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== onIdentityFollowChange) {
    t8 = () => {
      onIdentityFollowChange();
    };
    $[13] = onIdentityFollowChange;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== setToast) {
    t9 = error_0 => {
      setToast({
        message: error_0 as unknown as string,
        type: "error"
      });
    };
    $[15] = setToast;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setMutating(false);
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t11 = {
      mutationFn: t7,
      onSuccess: t8,
      onError: t9,
      onSettled: t10
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const unFollowMutation = useMutation(t11);
  let t12;
  if ($[22] !== followMutation || $[23] !== following || $[24] !== requestAuth || $[25] !== unFollowMutation) {
    t12 = async () => {
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setMutating(false);
        return;
      }
      if (following) {
        await unFollowMutation.mutateAsync();
        return;
      }
      await followMutation.mutateAsync();
    };
    $[22] = followMutation;
    $[23] = following;
    $[24] = requestAuth;
    $[25] = unFollowMutation;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const onFollow = t12;
  const t13 = `${FOLLOW_BTN_BUTTON_CLASSES[size]} ${following ? "tw-bg-iron-800 tw-ring-iron-800 tw-text-iron-300 hover:tw-bg-iron-700 hover:tw-ring-iron-700" : "tw-bg-primary-500 tw-ring-primary-500 hover:tw-bg-primary-600 hover:tw-ring-primary-600 tw-text-white"} tw-flex tw-items-center tw-cursor-pointer tw-rounded-lg tw-font-semibold tw-border-0 tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t14;
  if ($[27] !== following || $[28] !== mutating || $[29] !== size) {
    t14 = mutating ? <CircleLoader size={FOLLOW_BTN_LOADER_SIZES[size]} /> : following ? <svg className="tw-h-3 tw-w-3" width="17" height="15" viewBox="0 0 17 15" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M14.7953 0.853403L5.24867 10.0667L2.71534 7.36007C2.24867 6.92007 1.51534 6.8934 0.982005 7.26674C0.462005 7.6534 0.315338 8.3334 0.635338 8.88007L3.63534 13.7601C3.92867 14.2134 4.43534 14.4934 5.00867 14.4934C5.55534 14.4934 6.07534 14.2134 6.36867 13.7601C6.84867 13.1334 16.0087 2.2134 16.0087 2.2134C17.2087 0.986737 15.7553 -0.093263 14.7953 0.84007V0.853403Z" fill="currentColor" /></svg> : <svg className={FOLLOW_BTN_SVG_CLASSES[size]} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[27] = following;
    $[28] = mutating;
    $[29] = size;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== label) {
    t15 = <span>{label}</span>;
    $[31] = label;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== mutating || $[34] !== onFollow || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-2"><button onClick={onFollow} disabled={mutating} type="button" className={t13}>{t14}{t15}</button></div>;
    $[33] = mutating;
    $[34] = onFollow;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
export default NotificationsFollowBtn;
function _temp(i) {
  return i !== ApiIdentitySubscriptionTargetAction.DropVoted;
}
function _temp2(i_0) {
  return i_0 !== ApiIdentitySubscriptionTargetAction.DropVoted;
}